import { useState } from 'react';
import { ChatImageLightbox } from '@shared/ui/ChatImageLightbox';

type Props = {
  src: string;
  alt: string;
  className?: string;
};

/** Превью картинки; по клику — просмотр на весь экран. */
export function ZoomableImage({ src, alt, className }: Props) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        className="zoomable-image"
        onClick={() => setOpen(true)}
        aria-label={`Увеличить: ${alt}`}
      >
        <img src={src} alt={alt} className={className} />
      </button>
      {open ? (
        <ChatImageLightbox
          urls={[src]}
          index={0}
          onClose={() => setOpen(false)}
          onIndexChange={() => {}}
        />
      ) : null}
    </>
  );
}
